import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (max-width: 450px) {
    gap: 0.5rem;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background_white};
  margin: 3rem 0;
  width: 75%;
  padding-right: 1rem;

  h2 {
    color: ${({ theme }) => theme.colors.text};
    margin: 2rem 0 1rem 0;
    font-size: 1.3rem;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;

    h1 {
      font-weight: 300;
      color: ${({ theme }) => theme.colors.tertiary_500};
      margin: 0;
      font-size: 18px;
    }

    .buttonsImport {
      display: flex;
      gap: 0.5rem;

      button {
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.colors.tertiary_500};
        border: none;
        background-color: transparent;

        svg {
          padding: 0.5rem;
        }

        transition: opacity 0.2s;
        text-decoration: none;

        &:hover {
          opacity: 0.85;
        }

        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }
    }
  }

  .cnt-departments {
    padding-top: 1rem;

    .departments-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .transfer {
        display: flex;
        align-items: flex-end;

        .transferButton {
          display: flex;
          align-items: center;
          font-size: 16px;
          border: none;
          padding: 0;
          outline: 0;
          background: none;
          transition: opacity 0.2s;
          &:hover,
          &:focus {
            opacity: 0.55;
          }
        }

        span {
          text-align: left;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 0px;
          color: ${({ theme }) => theme.colors.secondary};
          opacity: 1;
          padding-right: 1rem;
        }

        .text-transfer {
          font: normal normal 300 16px/23px Futura PT;
          letter-spacing: -0.4px;
          color: ${({ theme }) => theme.colors.tertiary_500};
          opacity: 1;
          padding-left: 5px;
          text-decoration: underline;
          white-space: nowrap;
        }

        .icon-transfer {
          display: flex;
          font: normal normal 300 16px/23px Futura PT;
          letter-spacing: -0.4px;
          color: ${({ theme }) => theme.colors.tertiary_500};
          opacity: 1;
        }
      }

      .filter {
        display: flex;
        align-items: flex-end;
        width: 308px;

        .text-field {
          width: 100%;
        }

        .icon-search {
          display: flex;
          font-size: 30px;
          margin-left: -25px;
        }

        svg {
          color: ${({ theme }) => theme.colors.tertiary_500};
        }
      }
    }
  }

  .cnt-transfer {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .transfer-header {
      display: flex;
      justify-content: end;
      padding-top: 20px;

      .button-close {
        display: flex;
        color: ${({ theme }) => theme.colors.tertiary_500};

        button {
          font: normal normal 300 16px/23px Futura PT;
          letter-spacing: -0.4px;
          opacity: 1;
          background: transparent;
          padding: 0;

          span {
            padding-right: 5px;
            text-transform: initial;
            text-decoration: underline;
          }
        }

        svg {
          border-radius: 50%;
          background: ${({ theme }) => theme.colors.tertiary_500};
          color: white;
          width: 15px;
          height: 15px;
        }
      }
    }

    .transfer {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 1rem;

      .containerTransfers {
        width: 80%;
        display: flex;
        gap: 1rem;

        p {
          font-size: 1rem;
          color: ${({ theme }) => theme.colors.text};
        }

        .title {
          padding: 0.5rem;
        }

        .transfer-primary {
          width: 47%;
        }

        .icon-transfer {
          display: flex;
          justify-content: center;
          align-items: center;
          color: ${({ theme }) => theme.colors.tertiary_500};
          width: 6%;

          svg {
            padding-top: 22px;
          }
        }

        .transfer-dragdrop {
          height: 2.2rem;
          border: 1px dashed ${({ theme }) => theme.colors.gray_275};
          border-radius: 16px;
          opacity: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;

          p {
            text-align: center;
          }

          .sc-jmfXTE div .department-created .department-name .name {
            width: 100%;
          }
        }
      }

      .button-transfer {
        align-self: self-end;

        button {
          width: 8rem !important;
          height: 2rem !important;
        }
      }

      .transfer-secondary {
        width: 47%;
      }
    }
  }

  .cnt-departments-created {
    display: flex;
    gap: 1rem;
    padding-top: 1.5rem;
    flex-wrap: wrap;

    .department-options {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .radio-buttons {
        color: ${({ theme }) => theme.colors.text};
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
          color: ${({ theme }) => theme.colors.tertiary_500};
          padding: 0;
        }

        p {
          margin: 0;
          padding: 0;
          margin-right: 0.2rem;
          font-size: 12px;
        }
      }
    }

    .icon-options {
      display: flex;

      svg {
        color: ${({ theme }) => theme.colors.tertiary_500};
        opacity: 1;
      }
    }
  }

  @media (max-width: 1000px) {
    .cnt-transfer .transfer .containerTransfers {
      gap: 0;
    }
  }

  @media (max-width: 900px) {
    width: auto;
    margin-top: 0;
    padding: 1rem 1.5rem;
  }

  @media (max-width: 764px) {
    .cnt-transfer .transfer {
      flex-direction: column;

      .containerTransfers {
        width: 100%;
      }

      .containerButtonTransfer {
        width: 100%;
        text-align: center;
      }
    }
  }

  @media (max-width: 520px) {
    .cnt-departments .departments-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;

      .transfer {
        order: 2;
      }

      .filter {
        order: 1;
        width: 100%;
      }
    }
  }

  @media (max-width: 493px) {
    padding: 0 1.5rem;

    .header {
      flex-direction: column;

      h1 {
        display: none;
      }

      .buttonsImport {
        flex-direction: column;
        width: 100%;
        gap: 0;

        button {
          padding: 0;

          svg {
            padding: 0.5rem;
          }
        }
      }
    }
  }

  @media (max-width: 340px) {
    .cnt-departments .departments-header .transfer {
      flex-direction: column;
      width: 100%;
      align-items: flex-start;

      .transferButton {
        align-self: flex-end;

        span {
          padding-right: 0;
        }
      }
    }

    .cnt-transfer .transfer .containerTransfers .transfer-dragdrop {
      padding: 0.5rem;
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.background};
  height: 3rem;
  border-radius: 1rem;

  .cnpj {
    width: 75%;
  }

  .add {
    display: flex;
    justify-content: flex-end;
    width: 50%;
  }

  @media (max-width: 450px) {
    flex-direction: column;
    padding: 1rem;
    height: fit-content;
    gap: 1rem;
  }
`;
